import { APIModel } from '@shared/interfaces';

import { PollingStatus } from './polling-status.enum';
import { StatusProvider } from './status-provider.enum';

export class TaxNotification implements APIModel {
    id = -1;
    creationDate = new Date();
    email?: string;
    personalTaxFile = -1;

    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.creationDate = data.created_at != null ? new Date(data.created_at) : this.creationDate;
        this.email = data.email;
        this.personalTaxFile = data.personal_tax_file ?? -1;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        return this;
    }
}

export enum NotificationType {
    Questionnaire = 'QUESTIONNAIRE',
    Result = 'RESULT',
}
